/* istanbul ignore file */
// TODO: Create test file

/* eslint-disable import/prefer-default-export */
export const SET_FETCHED_PRODUCT = 'setFetchedProduct';
export const SET_ACTIVE_PRODUCT_ID = 'setActiveProductId';
export const SET_FETCHING_STATUS = 'setFetchingStatus';
export const SET_SLIDEOUT_TITLE = 'setSlideouttitle';
export const SET_ACTIVE_SWATCH_COLOR = 'setActiveSwatchColor';
export const SET_FIRST_MOUNT = 'setFirstMount';
export const SET_NAVIGATION_SLIDEOUT = 'setNavigationSlideout';
export const SET_PREFERRED_COMPS = 'setPreferredComps';
export const SET_ACTIVE_EXISTING_DATA = 'setActiveExistingData';
